const VesselIDType = {
	IMO: "imo",
	MMSI: "mmsi",
	SPIRE: "spireId"
};
export default VesselIDType;
